/**
 * Search Configuration
 *
 * Configuration for global search functionality including
 * default search regions and Algolia settings.
 */

/**
 * Default bounding boxes for global search
 * When performing Algolia search without a specific map region,
 * these bounding boxes define the geographic search area.
 *
 * Format: { north, south, west, east }
 * where north > south and east > west
 */
export const SEARCH_BOUNDING_BOXES = {
  // United States (default)
  US: {
    north: 49.38, // Canada border
    south: 24.52, // Southern Florida
    west: -124.77, // Pacific coast
    east: -66.95, // Atlantic coast
  },

  // Global search (covers most inhabited areas)
  GLOBAL: {
    north: 85.0, // Near North Pole
    south: -85.0, // Near South Pole
    west: -180.0, // International Date Line
    east: 180.0, // International Date Line
  },

  // North America
  NORTH_AMERICA: {
    north: 83.0,
    south: 7.0,
    west: -168.0,
    east: -52.0,
  },
};

/**
 * Default search region
 * Can be overridden by environment configuration
 */
export const DEFAULT_SEARCH_REGION = 'US';

/**
 * Get the bounding box for a given region
 * @param {string} region - Region key (US, GLOBAL, NORTH_AMERICA)
 * @returns {object} Bounding box with north, south, west, east
 */
export function getSearchBoundingBox(region = DEFAULT_SEARCH_REGION) {
  return SEARCH_BOUNDING_BOXES[region] || SEARCH_BOUNDING_BOXES.US;
}

/**
 * Convert bounding box to API parameters
 * Backend expects: lat1 (north), lat2 (south), lng1 (west), lng2 (east)
 * where lat1 > lat2 and lng2 > lng1
 *
 * @param {string} region - Region key
 * @returns {object} API parameters { lat1, lat2, lng1, lng2 }
 */
export function getBoundingBoxParams(region = DEFAULT_SEARCH_REGION) {
  const box = getSearchBoundingBox(region);
  return {
    lat1: box.north,
    lat2: box.south,
    lng1: box.west,
    lng2: box.east,
  };
}

export default {
  SEARCH_BOUNDING_BOXES,
  DEFAULT_SEARCH_REGION,
  getSearchBoundingBox,
  getBoundingBoxParams,
};
